import React, {ReactNode} from "react";
import {
  Box,
} from "@material-ui/core";
import {Notify} from "../../components/notify/Notify";
import { TopBar } from "../../components/top-bar/TopBar";
import { Switch, Route, Redirect } from "react-router-dom";
import {FundingPage} from "./funding/FundingPage";
import {AssetsPage} from "./assets/AssetsPage";
import _ from "lodash";
import {AccountsPage} from "./accounts/AccountsPage";
import {TransactionPage} from "./transaction/TransactionPage";
import {AdminPage} from "../admin/AdminPage";
import {HistoricalPage} from "./historical/HistoricalPage";
import {ReportsPage} from "./reports/ReportsPage";
import {TradingPage} from "../trading/TradingPage";
import styled from "styled-components";
import { useProfile } from "../../hooks/useProfile";

interface PageItem {
  name?: string,
  path: string,
  roles: string[],
  component: () => ReactNode,
}

export const RootPages: {[key: string]: PageItem} = {
  admin: {
    name: 'Admin',
    path: '/admin',
    roles: ['admin'],
    component: () => <AdminPage />,
  },
  funding: {
    name: 'Account Balances',
    path: '/funding',
    roles: ['admin', 'client'],
    component: () => <FundingPage/>,
  },
  transactions: {
    path: '/transactions',
    roles: ['admin', 'client'],
    component: () => <TransactionPage />,
  },
  assets: {
    path: '/assets',
    roles: ['admin'],
    component: () => <AssetsPage />
  },
  historical: {
    path: '/historical',
    roles: ['admin', 'client'],
    component: () => <HistoricalPage />
  },
  accounts: {
    path: '/accounts',
    roles: ['admin'],
    component: () => <AccountsPage />
  },
  reports: {
    name: 'Reports',
    path: '/reports',
    roles: ['admin'],
    component: () => <ReportsPage />
  },
  trading: {
    name: 'Trading',
    path: '/trading',
    roles: ['admin', 'client'],
    component: () => <TradingPage />
  }
}

const Container = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const RootPage = () => {
  const { profile, client } = useProfile();

  return (
    <>
      <TopBar />
      <Container pl={6} pr={6} pt={11}>
        <Switch>
          {_.toPairs(RootPages).filter(([_, {name}]) => {
            if (name === 'Trading') {
              return (profile && profile.featureFlags && profile.featureFlags.includes('trading') && client?.tradingEnabled)
            } else if(name === 'Reports') {
              return (profile && profile.featureFlags && profile.featureFlags.includes('reports'))
            }
            return true
          }).map( ([key, {path, component}]) => component && (
            <Route key={key} path={path} >
              {component()}
            </Route>
          ))}
          <Route path='*'>
            <Redirect to='/funding' />
          </Route>
        </Switch>
      </Container>
      <Notify />
    </>
  );
};
